import React, { useEffect, useState } from 'react';
import { 
  Card, CardBody, CardTitle, Button, Form, FormGroup, Label, Input, 
  Row, Col, Alert, Spinner 
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from '../store/actions';
import api from '../utils/api';

const UserCreate = (props) => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    role: 'user',
    is_active: true
  });

  useEffect(() => {
    props.setBreadcrumbItems('إضافة مستخدم جديد', [
      { title: 'الرئيسية', link: '/dashboard' },
      { title: 'المستخدمين', link: '/dashboard/users' },
      { title: 'إضافة مستخدم جديد', link: '#' }
    ]);

    getCurrentUser();
  }, [props]);

  const getCurrentUser = () => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    setCurrentUser(userData);
    
    // إذا لم يكن أدمن، إعادة توجيه
    const role = (userData.role || userData.user_role || userData.type || '').toLowerCase();
    
    if (!userData || role !== 'admin') {
      navigate('/dashboard');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // مسح الخطأ عند التعديل
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'الاسم مطلوب';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'البريد الإلكتروني مطلوب';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'البريد الإلكتروني غير صحيح';
    }
    
    if (!formData.password) {
      errors.password = 'كلمة المرور مطلوبة';
    } else if (formData.password.length < 6) {
      errors.password = 'كلمة المرور يجب أن تكون 6 أحرف على الأقل';
    }
    
    if (formData.password !== formData.password_confirmation) {
      errors.password_confirmation = 'تأكيد كلمة المرور غير متطابق';
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    setLoading(true);
    
    try {
      console.log('Creating user with data:', formData); // ✅ للتشخيص
      await api.post('/users', formData);
      setSuccess('تم إنشاء المستخدم بنجاح');
      
      // إعادة توجيه بعد 2 ثانية
      setTimeout(() => {
        navigate('/dashboard/users');
      }, 2000);
      
    } catch (err) {
      console.error('User creation error:', err);
      
      if (err.response?.status === 422) {
        // أخطاء التحقق من الخادم
        setFormErrors(err.response.data.errors || {});
      } else {
        setError(err.response?.data?.message || 'حدث خطأ أثناء إنشاء المستخدم');
      }
    } finally {
      setLoading(false);
    }
  };

  // التحقق من الصلاحيات - محدث
  const role = currentUser?.role || currentUser?.user_role || currentUser?.type;
  if (!currentUser || (role !== 'admin' && role !== 'Admin')) {
    return (
      <Card>
        <CardBody className="text-center py-5">
          <i className="fas fa-lock fa-3x mb-3 text-muted"></i>
          <h5>غير مسموح</h5>
          <p className="text-muted">ليس لديك صلاحية للوصول لهذه الصفحة</p>
          <Button color="primary" onClick={() => navigate('/dashboard')}>
            العودة للرئيسية
          </Button>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card>
      <CardBody>
        <CardTitle className="h4 mb-4">إضافة مستخدم جديد</CardTitle>
        
        {error && <Alert color="danger">{error}</Alert>}
        {success && <Alert color="success">{success}</Alert>}
        
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="name">الاسم <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="أدخل الاسم الكامل"
                  value={formData.name}
                  onChange={handleChange}
                  invalid={!!formErrors.name}
                  className="form-control-lg"
                />
                {formErrors.name && <div className="invalid-feedback d-block">{formErrors.name}</div>}
              </FormGroup>
            </Col>
            
            <Col md={6}>
              <FormGroup>
                <Label for="email">البريد الإلكتروني <span className="text-danger">*</span></Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="أدخل البريد الإلكتروني"
                  value={formData.email}
                  onChange={handleChange}
                  invalid={!!formErrors.email}
                  className="form-control-lg"
                />
                {formErrors.email && <div className="invalid-feedback d-block">{formErrors.email}</div>}
              </FormGroup>
            </Col>
          </Row>
          
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="password">كلمة المرور <span className="text-danger">*</span></Label>
                <Input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="أدخل كلمة المرور"
                  value={formData.password}
                  onChange={handleChange}
                  invalid={!!formErrors.password}
                  className="form-control-lg"
                />
                {formErrors.password && <div className="invalid-feedback d-block">{formErrors.password}</div>}
              </FormGroup>
            </Col>
            
            <Col md={6}>
              <FormGroup>
                <Label for="password_confirmation">تأكيد كلمة المرور <span className="text-danger">*</span></Label>
                <Input
                  type="password"
                  name="password_confirmation"
                  id="password_confirmation"
                  placeholder="أعد إدخال كلمة المرور"
                  value={formData.password_confirmation}
                  onChange={handleChange}
                  invalid={!!formErrors.password_confirmation}
                  className="form-control-lg"
                />
                {formErrors.password_confirmation && <div className="invalid-feedback d-block">{formErrors.password_confirmation}</div>}
              </FormGroup>
            </Col>
          </Row>
          
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="role">الصلاحية</Label>
                <Input
                  type="select"
                  name="role"
                  id="role"
                  value={formData.role}
                  onChange={handleChange}
                  className="form-control-lg"
                >
                  <option value="user">مستخدم عادي</option>
                  <option value="data_entry">مدخل بيانات</option>
                  <option value="admin">أدمن</option>
                </Input>
              </FormGroup>
            </Col>
            
            <Col md={6}>
              <FormGroup>
                <Label for="is_active">حالة التفعيل</Label>
                <div className="mt-2">
                  <Input
                    type="checkbox"
                    name="is_active"
                    id="is_active"
                    checked={formData.is_active}
                    onChange={handleChange}
                    className="form-check-input me-2"
                  />
                  <Label for="is_active" className="form-check-label">
                    مفعل
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row>
          
          <Row className="mt-4">
            <Col>
              <Button 
                color="primary" 
                type="submit" 
                disabled={loading}
                className="me-2"
                size="lg"
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-1" />
                    جاري الإنشاء...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save me-1"></i>
                    إنشاء المستخدم
                  </>
                )}
              </Button>
              <Button 
                color="secondary" 
                onClick={() => navigate('/dashboard/users')}
                size="lg"
              >
                <i className="fas fa-times me-1"></i>
                إلغاء
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
};

export default connect(null, { setBreadcrumbItems })(UserCreate);
